var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.isComponent,{tag:"component",attrs:{"colors":_vm.colors,"capacity":_vm.capacity,"headimg":_vm.headimg,"routArg":_vm.routArg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }